import { render } from "./TokenError.vue?vue&type=template&id=03308b1a"
import script from "./TokenError.vue?vue&type=script&lang=js"
export * from "./TokenError.vue?vue&type=script&lang=js"

import exportComponent from "/home/danujaf/development/customer-survey/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__